(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flawluxe-lingerie-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flawluxe-lingerie-reviews')) {
    customElements.define('flawluxe-lingerie-reviews', class extends HTMLElement {
      connectedCallback() {
        this.cleanup();
        this.track = this.querySelector('.fl-lingerie-reviews__track');
        this.cards = Array.from(this.querySelectorAll('.fl-lingerie-reviews__card'));
        this.dots = Array.from(this.querySelectorAll('.fl-lingerie-reviews__dot'));
        this.pagination = this.querySelector('.fl-lingerie-reviews__pagination');
        if (!this.track || !this.cards.length) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.mobile = window.matchMedia('(max-width: 999px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateDots();
          });
        }, { ...options, passive: true });
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index), options);
          dot.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let next = index;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.dots.length - 1;
            if (event.key === 'ArrowRight') next = (index + 1) % this.dots.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.dots.length) % this.dots.length;
            this.dots[next].focus({ preventScroll: true });
            this.goTo(next);
          }, options);
        });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !this.mobile.matches) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = this.currentIndex();
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.cards.length - 1;
          if (event.key === 'ArrowRight') next = Math.min(next + 1, this.cards.length - 1);
          if (event.key === 'ArrowLeft') next = Math.max(next - 1, 0);
          this.goTo(next);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.findIndex((card) => card.contains(event.target));
          if (index >= 0) this.goTo(index, false);
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.updateDots());
        this.resizeObserver.observe(this.track);
        if (this.pagination) this.pagination.hidden = false;
        this.updateDots();
      }

      currentIndex() {
        const start = this.track.getBoundingClientRect().left;
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect().left - start);
          if (delta < distance) {
            distance = delta;
            closest = index;
          }
        });
        return closest;
      }

      goTo(index, animate = true) {
        if (!this.mobile.matches) return;
        const offset = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollBy({ left: offset, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      }

      updateDots() {
        const current = this.currentIndex();
        this.dots.forEach((dot, index) => {
          if (index === current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      cleanup() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      disconnectedCallback() {
        this.cleanup();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
